import { type AnyAction } from 'redux';

export const SET_USER_QUERY = 'SET_USER_QUERY';
export const SET_IS_DEEP_RESEARCH_ENABLED = 'SET_IS_DEEP_RESEARCH_ENABLED';
export const SET_IS_OPEN_AI_ENABLED = 'SET_IS_OPEN_AI_ENABLED';
export const SET_SELECTED_THREAD_MESSAGES = 'SET_SELECTED_THREAD_MESSAGES';
export const SET_FOCUSED_MESSAGE = 'SET_FOCUSED_MESSAGE';
export const SET_SHOW_LOADER = 'SET_SHOW_LOADER';
export const SET_SHOW_ACTIVITY_PANEL = 'SET_SHOW_ACTIVITY_PANEL';
export const SET_ACTIVITY_PANEL_TITLE = 'SET_ACTIVITY_PANEL_TITLE';
export const SET_ACTIVITY_PANEL_ACTIVE_TAB = 'SET_ACTIVITY_PANEL_ACTIVE_TAB';
export const SET_SHOW_PROGRESS_CARD = 'SET_SHOW_PROGRESS_CARD';
export const SET_PROGRESS_CARD_TITLE = 'SET_PROGRESS_CARD_TITLE';
export const SET_PROGRESS_PERCENTAGE = 'SET_PROGRESS_PERCENTAGE';
export const SET_ACTIVITY_PANEL_MESSAGE = 'SET_ACTIVITY_PANEL_MESSAGE';

export const setUserQuery = (query: string) => ({
  type: SET_USER_QUERY,
  payload: query
});

export const setIsDeepResearchEnabled = (enabled: boolean) => ({
  type: SET_IS_DEEP_RESEARCH_ENABLED,
  payload: enabled
});

export const setIsOpenAIEnabled = (enabled: boolean) => ({
  type: SET_IS_OPEN_AI_ENABLED,
  payload: enabled
});

export const setShowLoader = (show: boolean) => ({
  type: SET_SHOW_LOADER,
  payload: show
});

export const setSelectedThreadMessages = (messages: any) => ({
  type: SET_SELECTED_THREAD_MESSAGES,
  payload: messages
});

export const setFocusedMessage = (message: any) => ({
  type: SET_FOCUSED_MESSAGE,
  payload: message
});

export const setShowActivityPanel = (show: boolean) => ({
  type: SET_SHOW_ACTIVITY_PANEL,
  payload: show
});

export const setActivityPanelTitle = (title: string) => ({
  type: SET_ACTIVITY_PANEL_TITLE,
  payload: title
});

export const setActivityPanelActiveTab = (tab: string) => ({
  type: SET_ACTIVITY_PANEL_ACTIVE_TAB,
  payload: tab
});

export const setShowProgressCard = (show: boolean) => ({
  type: SET_SHOW_PROGRESS_CARD,
  payload: show
});

export const setProgressCardTitle = (title: string) => ({
  type: SET_PROGRESS_CARD_TITLE,
  payload: title
});

export const setProgressPercentage = (percentage: number) => ({
  type: SET_PROGRESS_PERCENTAGE,
  payload: percentage
});

export const setActivityPanelMessage = (message: any) => ({
  type: SET_ACTIVITY_PANEL_MESSAGE,
  payload: message
});
